import { render } from "./ImageScanner.vue?vue&type=template&id=d4cc020e&scoped=true"
import script from "./ImageScanner.vue?vue&type=script&lang=js"
export * from "./ImageScanner.vue?vue&type=script&lang=js"

import "./ImageScanner.vue?vue&type=style&index=0&id=d4cc020e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4cc020e"]])

export default __exports__